<script setup lang="ts">
import { upperFirst } from 'scule'

const props = defineProps<{
  shippingTimeString: {
    min: string
  }
}>()

const config = useRuntimeConfig()
const { t } = useI18n()

const deliveryStats = [
  { days: '≤4', percentage: 23.4 },
  { days: '5', percentage: 45.2 },
  { days: '5-7', percentage: 22.3 },
  { days: '7-10', percentage: 7.5 },
  { days: '10-12', percentage: 1.1 },
  { days: '12+', percentage: 0.5 },
] as const

const expressShippingTime = computed(() => {
  const min = +config.public.expressShippingTime.min
  const max = +config.public.expressShippingTime.max
  return { min, max }
})
</script>

<template>
  <div>
    <div class="space-y-4">
      <div class="flex flex-col gap-4 text-sm md:flex-row md:justify-between">
        <div class="mb-1 flex flex-col gap-2">
          <div class="font-semibold">
            {{ t('delivery.couriers') }}
          </div>
          <div class="flex items-center md:max-w-60">
            <CarrierLogos />
          </div>
        </div>

        <div class="mb-1 flex flex-row gap-x-2 font-semibold md:flex-col">
          <div>
            {{ t('delivery.estimated_from') }}:
          </div>
          <div class="relative font-extrabold after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[1px] after:translate-y-[3px] after:border-b after:border-slate-600 after:border-dashed md:text-center after:content-['']">
            {{ upperFirst(props.shippingTimeString.min) }}
          </div>
        </div>
      </div>
    </div>

    <div class="pt-3">
      <h3 class="mb-2 text-sm text-orange-600 font-semibold md:text-lg">
        {{ `${t('product.fastest_delivery.label')} ${t('delivery.within_n_working_days', expressShippingTime.min)}` }}
      </h3>

      <div class="space-y-3">
        <div v-for="stat in deliveryStats" :key="stat.days" class="flex flex-col md:flex-row md:items-center md:gap-0">
          <div class="w-full text-sm text-gray-700 md:w-1/3 md:flex-shrink-0">
            {{ `${stat.days} ${t('delivery.working_days')}` }}
          </div>

          <div class="w-full flex items-center gap-2 md:w-2/3">
            <div class="flex-1">
              <UiProgress :model-value="stat.percentage" :max="100" class="h-2" />
            </div>
            <span class="w-12 flex-shrink-0 text-sm text-gray-900 font-medium">{{ stat.percentage }}%</span>
          </div>
        </div>
      </div>
      <div class="mt-4 text-xs text-gray-500">
        {{
          t('product.fastest_delivery.tooltip', [`${expressShippingTime.min} - ${expressShippingTime.max}`])
        }}
      </div>
    </div>
  </div>
</template>
